<template>
  <div>
    <v-row no-gutters>
      <v-col cols="12" sm="12" md="12">
        <v-card-text class="ml-0 pl-0 mr-0 pr-0 append-outer-no-margin-top">
          <div class="shorten-input-anchor" v-if="!dto">
            <v-text-field
              v-model="url"
              flat
              rounded
              filled
              class="dash-shorten-input lowercase"
              :placeholder="$t('shortenToURLExample')"
              :rules="[rules.url]"
              hide-details
              :readonly="loading"
              @focus="urlFieldFocused = true"
              @blur="urlFieldFocused = false"
            >
              <template v-slot:append>
                <v-slide-x-transition>
                  <v-chip color="green" v-if="isPhoneNumber(url) && !loading" @click="dataDialogWhattsapp.dialog = true">
                    <v-icon>mdi-whatsapp</v-icon>
                  </v-chip>
                </v-slide-x-transition>
                <v-slide-x-transition>
                  <v-chip color="primary" v-if="loading">
                    <v-progress-circular x-small  indeterminate width="1" size="22"/>
                  </v-chip>
                </v-slide-x-transition>
                <v-fade-transition>
                  <v-tooltip left v-if="url && !isUrl(url) && !loading && !isPhoneNumber(url)">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn icon small v-bind="attrs" v-on="on" @click="url = ''"><v-icon color="#7E8EA6">mdi-close</v-icon></v-btn>
                    </template>
                    <span>{{$t(`clear`)}}</span>
                  </v-tooltip>
                </v-fade-transition>
              </template>
              <template v-slot:append-outer style="margin-top: auto;">
                <v-tooltip left v-if="url && isUrl(url) && !loading">
                  <template v-slot:activator="{ on, attrs }">
                    <button type="button" class="dash-shorten-btn dash-tactile" @click="save" v-bind="attrs" v-on="on">{{$t(`shorten`)}}</button>
                  </template>
                  <span>{{$t(`shortenAddress`)}}</span>
                </v-tooltip>
              </template>
            </v-text-field>
            <div
              class="shorten-typewriter"
              :class="{ 'shorten-typewriter-visible': urlFieldFocused && !url }"
              aria-hidden="true"
            >
              <small class="shorten-typewriter-label">{{ $t('home.heroTypewriterLabel') }}</small>
              <div class="shorten-typewriter-link">
                <span
                  v-for="(part, i) in typewriterVisibleParts"
                  :key="i"
                  :class="{ 'shorten-typewriter-highlight': part.highlight }"
                >{{ part.text }}</span><span class="shorten-typewriter-cursor">|</span>
              </div>
            </div>
          </div>
          <v-text-field
            id="copy"
            color="primary"
            text-color="primary"
            v-else
            rounded
            class="dash-shortened-result"
            :value="`${currentUrl}/${dto.code}`"
            :label="$t('shortenedUrl')"
            readonly
            filled
            hide-details
            hide-actions
            dense
            @click="copy"
          >
            <template v-slot:append>
              <v-tooltip left>
                <template v-slot:activator="{ on, attrs }">
                  <v-chip color="red" v-bind="attrs" v-on="on" @click="clear" small dark>
                    <v-icon small>mdi-restore</v-icon>
                  </v-chip>
                </template>
                <span>{{$t(`toClean`)}}</span>
              </v-tooltip>
            </template>
          </v-text-field>
          <v-card-actions class="mt-0 mb-0">
            <v-spacer/>
            <button type="button" class="dash-whatsapp-btn dash-tactile" @click="dataDialogWhattsapp.dialog = true">
              <span class="dash-whatsapp-btn-icon">
                <v-icon size="13" color="#FFFFFF">mdi-whatsapp</v-icon>
              </span>
              {{ $t('newLinkWhatsapp') }}
              <v-icon size="16" color="#128C4A" class="ml-1">mdi-chevron-right</v-icon>
            </button>
          </v-card-actions>
        </v-card-text>
        <v-slide-y-transition>
          <v-card-actions v-if="dto" class="pr-0 pl-0">
            <v-fade-transition>
              <v-chip dark color="green" v-if="showCopy" small>
                {{$t('urlCopiedToClipboard')}}
              </v-chip>
            </v-fade-transition>
            <v-spacer/>
            <div class="dash-shorten-actions">
              <v-tooltip left>
                <template v-slot:activator="{ on, attrs }">
                  <button type="button" class="dash-action-icon-btn dash-tactile" @click="copy" v-bind="attrs" v-on="on"><v-icon size="18" color="#0277BD">mdi-content-copy</v-icon></button>
                </template>
                <span>{{$t(`copyUrl`)}}</span>
              </v-tooltip>
              <v-tooltip left>
                <template v-slot:activator="{ on, attrs }">
                  <a :href="`${currentUrl}/${dto.code}`" target="_blank" v-bind="attrs" v-on="on" class="dash-action-icon-btn dash-tactile">
                    <v-icon size="18" color="#0277BD">mdi-navigation-variant</v-icon>
                  </a>
                </template>
                <span>{{$t(`viewUrl`)}}</span>
              </v-tooltip>
              <v-tooltip left>
                <template v-slot:activator="{ on, attrs }">
                  <button type="button" class="dash-action-icon-btn dash-tactile" v-bind="attrs" v-on="on" :disabled="!dto.user" @click="$router.push(`/painel/links/shortened/?onlineAddressId=${dto.id}&shortenedRecent=${dto.id}`), screenData.dashboard = true"><v-icon size="18" color="#0277BD">mdi-chart-arc</v-icon></button>
                </template>
                <span>{{$t(`toChart`)}}</span>
              </v-tooltip>
              <v-tooltip left>
                <template v-slot:activator="{ on, attrs }">
                  <button type="button" class="dash-action-icon-btn dash-tactile" @click="dialogQrcode = true" v-bind="attrs" v-on="on">
                    <v-icon size="18" color="#0277BD">mdi-qrcode</v-icon>
                  </button>
                </template>
                <span>QRCode</span>
              </v-tooltip>
            </div>
          </v-card-actions>
        </v-slide-y-transition>
      </v-col>
    </v-row>
    <v-dialog v-model="dialogQrcode" width="300">
      <QRCodeMigly v-if="dto" :value="`${currentUrl}/${dto.code}`" :enableControlls="true"/>
    </v-dialog>

    <v-bottom-sheet v-if="['xs' , 'sm'].includes($vuetify.breakpoint.name)" v-model="dataDialogWhattsapp.dialog">
      <UrlShortenerWhattsApp :data="dataDialogWhattsapp" :onSave="onSaveWhatsApp" :url="url"/>
    </v-bottom-sheet>
    <v-navigation-drawer 
      v-else
      v-model="dataDialogWhattsapp.dialog"
      fixed
      width="40%"
      height="100%"
      color="#F7F5EF"
      >
      <UrlShortenerWhattsApp :data="dataDialogWhattsapp" :onSave="onSaveWhatsApp" :url="url"/>
    </v-navigation-drawer>
    <v-overlay :value="dataDialogWhattsapp.dialog"></v-overlay>
  </div>
</template>
<script>
import {apiV1OnlineAddresses} from "../../../service/resources/api-v1-online-addresses";
import {isValidUrl} from "../../../service/url-validator";
import QRCodeMigly from "./QRCodeMigly.vue";
import UrlShortenerWhattsApp from "./UrlShortenerWhattsApp";
  export default {
    name: 'UrlShortener',
    props: ['screenData'],
    components: {
    QRCodeMigly,
    UrlShortenerWhattsApp
},
    data: () => ({
      showCopy: false,
      showInfo: true,
      dialogQrcode: false,
      url: null,
      dto: null,
      loading: false,
      currentUrl: null,
      rules: {url:false, phoneNumber: false},
      option: 0,
      dataDialogWhattsapp: {
        dialog: false
      },
      urlFieldFocused: false,
      typewriterText: '',
      typewriterWordIndex: 0,
      typewriterWords: [
        { parts: [{ text: 'seusite.com/produto-2024', highlight: false }] },
        { parts: [{ text: 'migly.in/', highlight: false }, { text: 'promocao-relampago', highlight: true }] },
        { parts: [{ text: 'migly.in/', highlight: false }, { text: 'curso-online', highlight: true }] },
        { parts: [{ text: 'migly.in/', highlight: false }, { text: 'tenis', highlight: true }] },
        { parts: [{ text: 'migly.in/', highlight: false }, { text: 'livro', highlight: true }] },
        { parts: [{ text: 'sua-empresa', highlight: true }, { text: '.migly.in/', highlight: false }, { text: 'links', highlight: true }] },
      ],
      typewriterTimer: null,
    }),
    watch: {

    },
    mounted: function() {
      this.currentUrl = `${window.location.protocol}//${window.location.host.replace('www.', '')}`;

      this.rules = {
        url: value => {
          return (this.isUrl(value)) || this.$t('invalidUrl')
        },
        phoneNumber: value => {
          return (this.isPhoneNumber(value)) || this.$t('invalidPhone')
        }
      }

      const prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches
      if (prefersReducedMotion) {
        this.typewriterWordIndex = 0
        this.typewriterText = this.typewriterFullText(this.typewriterWords[0])
      } else {
        this.runTypewriter(0)
      }
    },
    beforeDestroy: function() {
      if (this.typewriterTimer) clearTimeout(this.typewriterTimer)
    },
    computed: {
      typewriterVisibleParts: function() {
        const entry = this.typewriterWords[this.typewriterWordIndex]
        const visibleLen = this.typewriterText.length
        let consumed = 0
        const result = []
        for (const part of entry.parts) {
          if (consumed >= visibleLen) break
          const chunk = part.text.slice(0, visibleLen - consumed)
          if (chunk) result.push({ text: chunk, highlight: part.highlight })
          consumed += part.text.length
        }
        return result
      },
    },
    methods: {
      typeChars: function(fullText, from, to, onDone) {
        this.typewriterText = fullText.slice(0, from)
        if (from < to) {
          this.typewriterTimer = setTimeout(() => this.typeChars(fullText, from + 1, to, onDone), 70)
        } else {
          onDone()
        }
      },
      eraseChars: function(fullText, from, to, onDone) {
        this.typewriterText = fullText.slice(0, from)
        if (from > to) {
          this.typewriterTimer = setTimeout(() => this.eraseChars(fullText, from - 1, to, onDone), 35)
        } else {
          onDone()
        }
      },
      typewriterFullText: function(entry) {
        return entry.parts.map(p => p.text).join('')
      },
      typewriterSharedPrefixLength: function(a, b) {
        let i = 0
        while (i < a.length && i < b.length && a[i] === b[i]) i++
        return i
      },
      runTypewriter: function(wordIndex) {
        this.typewriterWordIndex = wordIndex
        const words = this.typewriterWords
        const current = words[wordIndex]
        const nextIndex = (wordIndex + 1) % words.length
        const next = words[nextIndex]
        const fullCurrent = this.typewriterFullText(current)
        const fullNext = this.typewriterFullText(next)
        const eraseTo = this.typewriterSharedPrefixLength(fullCurrent, fullNext)
        const startFrom = this.typewriterText.length
        this.typeChars(fullCurrent, startFrom, fullCurrent.length, () => {
          this.typewriterTimer = setTimeout(() => {
            this.eraseChars(fullCurrent, fullCurrent.length, eraseTo, () => {
              this.typewriterTimer = setTimeout(() => {
                this.runTypewriter(nextIndex)
              }, 300)
            })
          }, 1400)
        })
      },
      isUrl: function(value) {
        return isValidUrl(value)
      },
      save: function () {
        this.loading = true
        apiV1OnlineAddresses
        .post({url: this.url})
        .then(response => {
            this.dto = response.data
            this.loading = false
            setTimeout(() => {
              this.copy()
              //this.screenData.page.content.splice(0, 0, response.data)
              let query = JSON.parse(JSON.stringify(this.$route.query))

              if(this.screenData.auth && this.screenData.auth.user) {
                query.shortenedRecent = this.dto.id
                this.$router.push({path: `/painel/links/shortened`, query: query})
              }

              if((!response.data.openGraph || !response.data.openGraph.openGraphFields) && response.data.user && response.data.user.shorterProUserOrBetter) {
                this.$commons.updateSnackbar({show: true, color: 'info', text: this.$t('linkAparencePreview')})
              }else if (this.screenData.auth && this.screenData.auth.user && this.screenData.auth.user.shorterProUserOrBetter && !this.screenData.auth.user.config) {
                this.$commons.updateSnackbar({show: true, color: 'info', text: this.$t('configPageLoadInfo')})
              }
            }, 200);
          }
        ).catch(() => {
          this.loading = false
        })
      },
      copy: function () {
        let element = document.querySelector('#copy');
        element.setAttribute('type', 'text') 
        element.select()
        document.execCommand('copy');
        setTimeout(() => {
          this.showCopy = true
          setTimeout(() => {
            this.showCopy = false
          }, 2000);
        }, 500);
      },
      clear: function () {
        this.url = null
        this.dto = null
        this.$ga.event('btn', 'click', 'clear-url-shotner', 1)
      },
      isPhoneNumber: function (value) {
        let number = (value? value : '').replace(/\D/g, "")
        return /^\d{8,15}$/.test(number);
      },
      onSaveWhatsApp: function(url) {
        this.url = url
        this.save()
        this.dataDialogWhattsapp.dialog = false
      }
    },
  }
</script>
<style scoped>

.v-input__append-outer {
  margin-top: auto !important;
}

.dash-shorten-input ::v-deep .v-input__slot {
  background: #F7F5EF !important;
  box-shadow: none !important;
  border: 1px solid rgba(16,24,39,0.08);
}
.dash-shorten-input ::v-deep .v-input__slot:hover {
  border-color: rgba(2, 119, 189, 0.35);
}
.dash-shorten-input ::v-deep .v-input__slot:focus-within {
  border-color: #0277BD;
}
.dash-shorten-input ::v-deep input::placeholder {
  color: #7E8EA6;
  opacity: 1;
}
/*
 * The full placeholder ("Exemplo youtube.com ou um número de telefone") is
 * wider than the input on narrow screens; without this the browser hard-clips
 * it mid-word with no ellipsis. text-overflow only takes effect on an input
 * with overflow hidden, and browsers apply it to the placeholder too.
 */
.dash-shorten-input ::v-deep input {
  overflow: hidden;
  text-overflow: ellipsis;
}
.dash-shorten-btn {
  display: inline-flex;
  align-items: center;
  border: none;
  border-radius: 999px;
  padding: 0.7rem 1.4rem;
  background: linear-gradient(90deg, #00BDB3 0%, #0277BD 100%);
  color: #FFFFFF;
  font-family: 'Montserrat', sans-serif;
  font-weight: 700;
  font-size: 0.9rem;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  box-shadow: 0 8px 18px rgba(2, 119, 189, 0.28);
}
.dash-shorten-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 24px rgba(2, 119, 189, 0.38);
}
.dash-shortened-result ::v-deep .v-input__slot {
  border-color: rgba(16,24,39,0.1) !important;
  background: #F7F5EF;
}
.dash-whatsapp-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  border: 1px solid rgba(37,211,102,0.3);
  background: rgba(37,211,102,0.08);
  border-radius: 999px;
  padding: 0.4rem 0.9rem 0.4rem 0.4rem;
  color: #128C4A;
  font-family: 'Montserrat', sans-serif;
  font-weight: 700;
  font-size: 0.8rem;
  cursor: pointer;
  transition: background 0.2s ease, transform 0.2s ease, box-shadow 0.2s ease;
}
.dash-whatsapp-btn:hover {
  background: rgba(37,211,102,0.16);
  transform: translateY(-1px);
  box-shadow: 0 8px 18px rgba(37,211,102,0.2);
}
.dash-whatsapp-btn-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: #25D366;
  flex-shrink: 0;
}
.dash-shorten-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}
.dash-action-icon-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border-radius: 50%;
  border: none;
  background: #E3F1FA;
  cursor: pointer;
  text-decoration: none;
  transition: background 0.2s ease, transform 0.2s ease;
}
.dash-action-icon-btn:hover {
  background: #DDEBFA;
  transform: translateY(-1px);
}
.dash-action-icon-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
.shorten-input-anchor {
  position: relative;
}
.shorten-typewriter {
  position: absolute;
  top: calc(100% + 10px);
  left: 0;
  right: 0;
  z-index: 20;
  padding: 0.9rem 1rem;
  background: #FFFFFF;
  border-radius: 1.25rem;
  border: 1px solid rgba(16,24,39,0.07);
  box-shadow: 0 16px 32px rgba(16,24,39,0.14);
  opacity: 0;
  pointer-events: none;
  transform: translateY(-6px);
  transition: opacity 0.2s ease, transform 0.2s ease;
}
.shorten-typewriter-visible {
  opacity: 1;
  pointer-events: auto;
  transform: translateY(0);
}
@media (prefers-reduced-motion: reduce) {
  .shorten-typewriter {
    transition: opacity 0.2s ease;
    transform: none;
  }
}
.shorten-typewriter::before {
  content: '';
  position: absolute;
  top: -7px;
  left: 32px;
  width: 0;
  height: 0;
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  border-bottom: 7px solid #FFFFFF;
  filter: drop-shadow(0 -2px 2px rgba(16,24,39,0.05));
}
.shorten-typewriter-label {
  display: block;
  color: #5B6472;
  font-size: 0.8rem;
  margin-bottom: 0.3rem;
}
.shorten-typewriter-link {
  font-family: 'Montserrat', sans-serif;
  font-weight: 800;
  font-size: 1.2rem;
  color: #0277BD;
  min-height: 1.6rem;
  word-break: break-all;
}
.shorten-typewriter-highlight {
  color: #00BDB3;
  text-decoration: underline;
  text-decoration-style: dashed;
  text-decoration-color: rgba(0,189,179,0.5);
  text-underline-offset: 3px;
}
.shorten-typewriter-cursor {
  display: inline-block;
  margin-left: 2px;
  animation: shorten-typewriter-blink 1s step-end infinite;
}
@keyframes shorten-typewriter-blink {
  50% { opacity: 0; }
}
@media (prefers-reduced-motion: reduce) {
  .shorten-typewriter-cursor {
    animation: none;
  }
}
</style>